export default __webpack_public_path__ + "static/marta-3695b33c6d86b2d9d5116bf591a7dcb0.webp";